import api from '@/store/api'
import { getField, updateField } from 'vuex-map-fields'

const state = {
	subscribers: {
		data: [],
		last_page: 0,
		total: 0,
		to: 0,
		from: 0
	},
	users: {
		data: [],
		current_page: 1,
		total: 0,
		to: 0,
		from: 0
	},
	plans: {
		data: [],
		current_page: 1,
		last_page: 0,
		total: 0,
		to: 0,
		from: 0
	},
	filter: {
		keyword: '',
		page: 1,
		count: 10,
		sort_by: ''
	},
	userFilter: {
		keyword: '',
		page: 1,
		count: 10
	},
	planFilter: {
		keyword: '',
		page: 1,
		count: 10
	},
	form: {
		account: '',
		plan: ''
	},
	errors: {
		title: '',
		artist: '',
		theme: '',
		classification: {
			alpha: '',
			beta: '',
			delta: ''
		},
		music: ''
	},
	progress: 0,
	isLoading: false,
	userIsLoading: false,
	showBindAccountForm: false,
	planIsLoading: false,
	submitLoading: false
}

const mutations = {
	updateField
}

const actions = {
	async subscribe ({ state, dispatch }, payload) {
		state.submitLoading = true
		const { data, status } = await api('post', 'subscribe', payload)

		if (status) {
			state.form = {
				account: '',
				plan: ''
			}
			state.showBindAccountForm = false
			dispatch('toggleBanner', {
				message: 'Account and Subscription Plan has been bound.',
				type: 'success'
			}, { root: true })
		} else {
			dispatch('toggleBanner', {
				message: data.message || 'Something went wrong.',
				type: 'error'
			}, { root: true })
		}
		state.submitLoading = false
	},
	async list ({ state }, payload) {
		state.isLoading = true
		const { data, status } = await api('get', `subscribed-user-list${payload}`)

		if (status) {
			state.subscribers.data = data.data.data
			state.filter.page = data.data.current_page
			state.subscribers.last_page = data.data.last_page
			state.subscribers.total = data.data.total
			state.subscribers.to = data.data.to
			state.subscribers.from = data.data.from
			state.filter.count = Number(data.data.per_page)
		} else {
			state.subscribers = []
		}
		state.isLoading = false
	},
	async userList ({ state }, payload) {
		state.userIsLoading = true
		const { data, status } = await api('get', `user-list${payload}`)

		if (status) {
			state.users.data = [...state.users.data, ...data.data.data]
			state.userFilter.page = data.data.current_page
			state.users.last_page = data.data.last_page
			state.users.total = data.data.total
			state.users.to = data.data.to
			state.users.from = data.data.from
			state.userFilter.count = Number(data.data.per_page)
		} else {
			state.users = []
		}
		state.userIsLoading = false
	},
	async planList ({ state }, payload) {
		state.planIsLoading = true
		const { data, status } = await api('get', `plan-list${payload}`)

		if (status) {
			state.plans.data = [...state.plans.data, ...data.data.data]
			state.planFilter.page = data.data.current_page
			state.plans.last_page = data.data.last_page
			state.plans.total = data.data.total
			state.plans.to = data.data.to
			state.plans.from = data.data.from
			state.planFilter.count = Number(data.data.per_page)
		} else {
			state.plans = []
		}
		state.planIsLoading = false
	},
	async downloadList ({ dispatch }) {
		state.isLoading = true
		const { data } = await api('post', 'download-list', null, true)
		const url = window.URL.createObjectURL(new Blob([data]))
		const link = document.createElement('a')
		const date = new Date().toLocaleDateString()
		link.setAttribute('href', url)
		link.download = `subscribers-${date}.xlsx`
		link.style.display = 'none'
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		dispatch('toggleBanner', {
			message: 'Subscribers has been downloaded.',
			type: 'success'
		}, { root: true })
		state.isLoading = false
	}
}

const getters = {
	getField,
	subscriberList: state => state.subscribers,
	userList: state => state.users,
	planList: state => state.plans,
	isLoading: state => state.isLoading,
	submitLoading: state => state.submitLoading,
	userIsLoading: state => state.userIsLoading,
	planIsLoading: state => state.planIsLoading
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
